module.exports = __webpack_public_path__ + "static/media/investor_data_.9afe0612.svg";